import { useConfiguratorSide } from '@/app/store/configurator/hooks/use-configurator-side';
import { EditorSide } from '@/shared/types/configurator';
import { useTranslation } from 'react-i18next';
import { BoxSide, BoxTop } from '../../assets/box';
import { Action } from '../action/action';
import styles from './side-actions.module.css';

export const SideActions = () => {
	const { side, setSide } = useConfiguratorSide();
	const { t } = useTranslation();

	return (
		<div className={styles.wrapper}>
			<Action
				tooltip={t('actions.frontEditor')}
				active={side === EditorSide.FRONT}
				onClick={() => setSide(EditorSide.FRONT)}
				icon={{
					component: BoxTop,
					fillIcon: true,
				}}
			/>
			<Action
				tooltip={t('actions.sideEditor')}
				active={side === EditorSide.SIDE}
				onClick={() => setSide(EditorSide.SIDE)}
				icon={{
					component: BoxSide,
					fillIcon: true,
				}}
			/>
			<Action
				tooltip={t('actions.topEditor')}
				active={side === EditorSide.TOP}
				onClick={() => setSide(EditorSide.TOP)}
				icon={{
					component: BoxTop,
					fillIcon: true,
				}}
			/>
		</div>
	);
};
